module.exports = __webpack_public_path__ + "img/stock4.887dd712.png";